import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Footer from "../Components/Footer";
import Head from "../Components/Head";
import Header from "../Components/Header";
import Layout from "../Components/Layout";

const View = ({ onNext, onBack, signatureLink }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const yousignRef = useRef(null);
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (!signatureLink) {
      setError("No signature link provided");
      setLoading(false);
      return;
    }

    const initializeYouSign = () => {
      try {
        // Clean up previous instance if exists
        if (yousignRef.current) {
          yousignRef.current = null;
        }

        // Clear the container before initializing
        const container = document.getElementById("iframe-container");
        if (container) container.innerHTML = "";

        // Create new YouSign instance
        yousignRef.current = new window.Yousign({
          signatureLink,
          iframeContainerId: "iframe-container",
          isSandbox: process.env.REACT_APP_YOUSIGN_SANDBOX === "true",
        });

        yousignRef.current.onSuccess((result) => {
          setLoading(false);
          onNext(result);
        });

        yousignRef.current.onError((err) => {
          console.error("YouSign iFrame error:", err);
          setError("Failed to load signature document. Please try again.");
          setLoading(false);
        });

        // Check if iframe loaded successfully
        const checkFrame = setInterval(() => {
          const iframe = document.querySelector("#iframe-container iframe");
          if (iframe) {
            const iframeDoc =
              iframe.contentDocument || iframe.contentWindow.document;
            // Check for error content
            if (
              iframeDoc.body &&
              iframeDoc.body.innerText.includes(
                "Désolé, ce contenu n'est pas disponible"
              )
            ) {
              setError(
                "The signature document is not available. The link may be expired or invalid."
              );
              setLoading(false);
              clearInterval(checkFrame);
            }
            // If content is loaded, clear the interval
            else if (iframeDoc.readyState === "complete") {
              setLoading(false);
              clearInterval(checkFrame);
            }
          }
        }, 500);
      } catch (err) {
        console.error("YouSign initialization error:", err);
        setError("Failed to initialize signature service");
        setLoading(false);
      }
    };

    // If script is already loaded, just initialize
    if (scriptLoadedRef.current) {
      initializeYouSign();
      return;
    }

    // If SDK is already available globally
    if (window.Yousign) {
      scriptLoadedRef.current = true;
      initializeYouSign();
      return;
    }

    // Create and load the script
    const script = document.createElement("script");
    script.src = "https://cdn.yousign.tech/iframe-sdk-1.5.0.min.js";
    script.integrity =
      "sha384-wrNTU81R+b2K+9A1aE1c3blhReNpdRK6Tn1fzXOXhWGZGUk+Btp0dyfnk45pVpOr";
    script.crossOrigin = "anonymous";

    script.onload = () => {
      scriptLoadedRef.current = true;
      initializeYouSign();
    };

    script.onerror = () => {
      setError("Failed to load signature service");
      setLoading(false);
    };

    document.body.appendChild(script);

    // Cleanup function
    return () => {
      // Destroy YouSign instance if exists
      if (yousignRef.current) {
        try {
          // Some SDKs have a destroy method - use if available
          if (typeof yousignRef.current.destroy === "function") {
            yousignRef.current.destroy();
          }
        } catch (e) {
          console.warn("Error destroying YouSign instance:", e);
        }
        yousignRef.current = null;
      }

      // Clear the container
      const container = document.getElementById("iframe-container");
      if (container) container.innerHTML = "";

      // Don't remove the script - it can be reused
    };
  }, [signatureLink, onNext]);

  return (
    <>
      <Header />
      <div className="lmf__main">
        <Layout>
          <Head
            description="Signez votre <span class='highlight'>adhésion</span>"
            title={"Signature électronique"}
          />
          <div className="solyon__body">
            <div id="iframe-container"></div>
          </div>
          <Footer />
        </Layout>
      </div>
    </>
  );
};

export default View;
